import { render, staticRenderFns } from "./GenericDashboardWidget.vue?vue&type=template&id=47d62e8f&scoped=true"
import script from "./GenericDashboardWidget.vue?vue&type=script&lang=js"
export * from "./GenericDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./GenericDashboardWidget.vue?vue&type=style&index=0&id=47d62e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d62e8f",
  null
  
)

export default component.exports